import { findQueryByShape } from '@takeshape/schema';
import connected from 'app/common/utils/connected';
import { setPreviewRoute } from 'app/content-preview/slice';
import { getPermission } from 'app/permissions/selectors';
import { getCurrentProjectId } from 'app/project/selectors';
import { getSchema } from 'app/schema';
import type { InferableComponentEnhancerWithProps } from 'react-redux';
import type { AppState } from '../../app-state.js';
import { SHAPE_NAME } from '../../sites/constants.js';
import { getContentUsage, getPreviewRoutes } from '../actions.js';
import { selectLiveLinks, selectSitePreviewState, selectSiteUsageState } from '../selectors.js';
import type { LiveLinksDispatchProps, LiveLinksOwnProps, LiveLinksProps, LiveLinksStateProps } from '../types.js';

export function mapStateToProps(state: AppState, props: LiveLinksOwnProps): LiveLinksStateProps {
  const projectId = getCurrentProjectId(state);
  const projectSchema = getSchema(state);
  const sitesListQueryName = findQueryByShape(projectSchema, SHAPE_NAME, 'shapedb:list');
  const canViewSites = sitesListQueryName
    ? getPermission(state, {
        action: 'graphql:execute',
        resource: `ts:graphql:${projectId}:Query.${sitesListQueryName}`
      })
    : false;
  const sites = selectLiveLinks(state, props);
  const usageState = selectSiteUsageState(state, props);
  const previewState = selectSitePreviewState(state);
  return {
    canViewSites,
    projectId,
    usageState,
    previewState,
    sites
  };
}

export function ensureContent(newProps: LiveLinksProps, props?: LiveLinksProps): void {
  const { usageState, previewState, contentId, getContentUsage, getPreviewRoutes, canViewSites } = newProps;
  if (canViewSites && !usageState.loading && (props ? props.contentId !== contentId : contentId)) {
    getContentUsage(contentId);
  }

  if (canViewSites && !previewState.error && !previewState.loading && !previewState.loaded) {
    getPreviewRoutes();
  }
}

type GetContentUsage = ReturnType<typeof getContentUsage.requested>;

const mapDispatchToProps = {
  getContentUsage: (contentId: string): GetContentUsage => getContentUsage.requested({ contentId }, { contentId }),
  getPreviewRoutes: getPreviewRoutes.requested,
  setPreviewRoute
};

export const connectLiveLinks: InferableComponentEnhancerWithProps<
  LiveLinksStateProps & LiveLinksDispatchProps,
  LiveLinksOwnProps
> = connected({
  mapDispatchToProps,
  mapStateToProps,
  onComponentWillMount: ensureContent,
  onComponentWillReceiveProps: ensureContent
});
